import styleInject from '#style-inject';styleInject(".adyen-checkout__paywithgoogle{height:var(--straumur__space-8xlg)}\n")